module.exports = __webpack_public_path__ + "fonts/Yekan.05727d32.woff";